import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import MultiCarouselPage from './MultiCarouselPage';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'

const EvaluateStudent = props => {

    const [name, setName] = useState('');
    const [headline, setHeadline] = useState('เราเห็นอุปนิสัยเชิงบวกอะไรในตัวนักเรียน');
    const [description, setDescription] = useState('หลายเรื่องราวที่เราได้พูดคุยกับนักเรียน ได้มองเห็นเรามองว่าอุปนิสัยเชิงบวกที่เราสัมผัสได้เกี่ยวกับนักเรียนคนนี้มีอะไรบ้าง');
    const [questionStrength, setQuestionStrength] = useState('');
    const [questionTextBox, setQuestionTextBox] = useState('');
    const [postAnswer, setPostAnswer] = useState([]);
    const [strengths, setStrengths] = useState([]);
    const [modalChooseIndex, setModalChooseIndex] = useState(null);
    const [answer, setAnswer] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalAnswer, setModalAnswer] = useState(null);
    const [iconChooseIndex, setIconChooseIndex] = useState(null);
    const [modalShowEndActivity, setModalShowEndActivity] = useState(false);
    const [modalShowEndActivityType, setModalShowEndActivityType] = useState('');
    const handleActiveIndex = (index) => { if ($(`${index}.card.active`)[0]) { $('.card').removeClass('active'); } else { $('.card').removeClass('active'); $(index).addClass('active'); } };
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [text1, setText1] = useState([]);
    const [testSelf, setTextSelf] = useState([]);
    const [alreadyAnswer, setAlreadyAnswer] = useState(false);
    const [targetId, setTargetId] = useState(null);
    // const [reStrengths, setReStrengths] = useState([]);


    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }


    useEffect(() => {
        // console.log('studentId');
        // console.log(props.studentId); //test 60c0e14921965c37a7c1b764
        setName(props.studentName);
        setTargetId(props.studentId)
        let newStrengths = []
        UserService.getStrengths().then((response) => {
            setStrengths(response.data.data)

            for (const [index, str] of response.data.data.entries()) {
                newStrengths[str.id] = {
                    image: str.imageUrl,
                    name: str.name,
                    description: str.description
                }
            }
            // setReStrengths(newStrengths)
            return response.data.data
        }).then((apiStrengths) => {
            UserService.getFriendShipList(props.studentId).then(
                (res) => {

                    console.log('getFriendShipList');
                    // console.log(res.data.data[0].others);    
                    var images0 = [];
                    var images1 = [];
                    var images2 = [];
                    var tempPercent = 0;
                    var stringHtml;

                    // var allAnswer = [[],[],[],[]];
                    var allAnswer0 = [];
                    var allAnswer1 = [];
                    var allAnswer2 = [];
                    var allAnswer3 = [];
                    var selfText = '';
                    var calIndex = 0;

                    // console.log(res.data.data[0].others);
                    for (const [index, aAnswer] of res.data.data[0].others.entries()) {


                        if (aAnswer.answers && aAnswer.user.roles.includes("TEACHER")) {
                            setAlreadyAnswer(true);
                            handleAlreadyAnswer(apiStrengths, aAnswer.answers)
                        }

                        if (aAnswer.user.roles[0].toLowerCase() !== 'teacher' && aAnswer.answerAt !== null) {

                            if (allAnswer0[aAnswer.answers[0].values[0]] === undefined) {
                                allAnswer0[aAnswer.answers[0].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[0].values[0]]++
                            }

                            if (allAnswer0[aAnswer.answers[1].values[0]] === undefined) {
                                allAnswer0[aAnswer.answers[1].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[1].values[0]]++
                            }


                            if (allAnswer0[aAnswer.answers[2].values[0]] === undefined) {
                                allAnswer0[aAnswer.answers[2].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[2].values[0]]++
                            }

                            if (props.studentId === aAnswer.user.id) {
                                console.log('setTextSelf')
                                selfText = aAnswer.answers[3].values[0];
                                setTextSelf(selfText);
                            } else {

                                allAnswer3[calIndex] = {
                                    'code': calIndex,
                                    'text': aAnswer.answers[3].values[0]
                                }
                                calIndex++;
                            }

                        }
                    }


                    // console.log(allAnswer0);
                    // var test = {'ju': 5, 'naja': 4, 'test': 9, 'hello': 6};
                    // console.log(test);
                    var myArr0 = Object.fromEntries(
                        Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                    );

                    Object.keys(myArr0).map((aArray, i) => {
                        // tempPercent = res.data.data.percentages[aArray]
                        // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                        if (allAnswer0[aArray] <= 1) {
                            stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                        } else {
                            stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;

                        }

                        var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', newStrengths[aArray], '.i0' + aArray) }} />
                        images0.push(temp);
                    })

                    // var myArr1 = Object.fromEntries(
                    //     Object.entries(allAnswer1).sort(([, a], [, b]) => b - a)
                    // );

                    // Object.keys(myArr1).map((aArray, i) => {
                    //     // tempPercent = res.data.data.percentages[aArray]
                    //     // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer1[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i1${aArray}" />`;

                    //     if(allAnswer1[aArray] <= 1 ){
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                    //     } else {
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer1[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;

                    //     }

                    //     var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i1-${i}" onClick={() => { cardClick(aArray, '.tab1', newStrengths[aArray], '.i1'+aArray ) }}/>
                    //     // images1.push(temp);
                    //     images0.push(temp);
                    // })    

                    // var myArr2 = Object.fromEntries(
                    //     Object.entries(allAnswer2).sort(([, a], [, b]) => b - a)
                    // );

                    // Object.keys(myArr2).map((aArray, i) => {
                    //     // tempPercent = res.data.data.percentages[aArray]
                    //     // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer2[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i2${aArray}" />`;
                    //     if(allAnswer2[aArray] <= 1 ){
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                    //     } else {
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer2[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;

                    //     }

                    //     var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i2-${i}" onClick={() => { cardClick(aArray, '.tab2', newStrengths[aArray], '.i2'+aArray ) }}/>
                    //     // images2.push(temp);
                    //     images0.push(temp);
                    // })    

                    const itemsText = []

                    // for (const [index, value] of res.data.data.entries()) {
                    console.log(allAnswer3);
                    for (const [index, value] of allAnswer3.entries()) {
                        var temp = `<div class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value.text}</div></div>`;
                        temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" key="t-${index}" />
                        itemsText.push(temp);
                    }
                    setText1(itemsText);

                    return [images0, images1, images2];

                }).then((res) => {
                    setData1(res[0]);
                    // setData2(res[1]); 
                    // setData3(res[2]);     

                    return res[0]
                }).then((res) => {
                    myloop(res);
                })
        });

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // UserService.getAnswers(props.activityId, res.data.data.topic.questions[2].id).then((res) => {
        // const items = []
        // var temp = ['aaaaaaaaaaaaaaaaa aaa', 'bbbbbb bbbbbbbb bbbbbbbbbbbbb','ccccccccccc ccc','eeeeeee eeeeeeeee eeeeeeeeeeeeeeee'];
        // // for (const [index, value] of res.data.data.entries()) {
        // for (const [index, value] of temp.entries()) {    
        //     var temp = `<div class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value}</div></div>`;
        //     temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" key="t-${index}" />
        //     items.push(temp);               
        // }
        // setText1(items);           
        // })



        setAnswer([
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '' }
        ])
        UserService.getEvaluationForms('default').then((res) => {
            if (res.data && res.data.status && res.data.status.code === "SUCCESS") {
                //   setDescription(res.data.data.description)
                setQuestionTextBox(res.data.data.questions[3].title)
                setPostAnswer([
                    {
                        "title": res.data.data.questions[0].title,
                        "type": res.data.data.questions[0].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[1].title,
                        "type": res.data.data.questions[1].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[2].title,
                        "type": res.data.data.questions[2].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[3].title,
                        "type": res.data.data.questions[3].type,
                        "values": []
                    }
                ])
                setQuestionStrength([
                    //   res.data.data.questions[0].title,
                    //   res.data.data.questions[1].title,
                    //   res.data.data.questions[2].title
                    'เลือกอุปนิสัยเชิงบวกที่นักเรียนใช้บ่อยที่สุด',
                    'เลือกอุปนิสัยเชิงบวกที่นักเรียนใช้แล้วรู้สึกดีที่สุด',
                    'เลือกอุปนิสัยเชิงบวกที่บ่งบอกความเป็นนักเรียนมากที่สุด'
                ])
            }
        })

        UserService.getStrengths().then((response) => {
            setStrengths(response.data.data)
        });
    }, [])


    return (
        <div >
            <Row className="bg-light-blue">
                <Col xs={12} md={12} className="w-100 text-center pt-4 ">
                    <h2 class="font-sarabun-bold primary-text " ><div dangerouslySetInnerHTML={{ __html: headline }} className="anywhere-wrap" /> </h2>
                </Col>
            </Row>
            <Row style={{ "paddingBottom": "17px" }} className="bg-light-blue">
                <Col className="main-evaluate-overview">
                    <Row>
                        <Col xs={12} md={12} className="w-100 m-center-d-left pt-3">
                            <h4 class="font-sarabun-bold text-left">{description}</h4>
                        </Col>
                        <Col xs={12} md={12} className="text-center p-0">
                            <div className="bg-review d-flex">
                                <div class="m-auto">
                                    <h3 class="font-sarabun-bold">{name}</h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col className="text-left mt-4 main-evaluate-overview">
                    <h5><label style={{ paddingRight: "5px" }} className="text-magenta font-sarabun-bold evaluate-click click-pointer" onClick={() => clickTab(".evaluate-click")}>ประเมิน&nbsp;</label>|<label className="gray-text4 report-click click-pointer" style={{ paddingLeft: "5px" }} onClick={() => clickTab(".report-click")}>&nbsp;ผลประเมิน</label></h5>
                </Col>
            </Row>
            <Row className="pt-3 pb-5 evaluate-tab">
                <Col className="main-evaluate-overview">
                    <Row>
                        <Col className="w-100 text-center">
                            <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  ลองค้นหาอุปนิสัยเชิงบวกในตัวนักเรียน</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        </Col>
                    </Row>
                    <Row className="mx-3 mb-3 md-5 strengths-box">
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[0] && answer[0].image) ? answer[0].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(0); }} />
                            {(!alreadyAnswer && answer[0] && answer[0].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(0); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[1] && answer[1].image) ? answer[1].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(1); }} />
                            {(!alreadyAnswer && answer[1] && answer[1].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(1); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[2] && answer[2].image) ? answer[2].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(2); }} />
                            {(!alreadyAnswer && answer[2] && answer[2].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(2); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                    </Row>
                    {
                        (answer[iconChooseIndex]) ?
                            <Row>
                                <Col className="w-100 px-4 mb-4">
                                    <div className="answer-detail">
                                        {
                                            (iconChooseIndex !== null && questionStrength[iconChooseIndex]) ?
                                                <h5 className="choice" align="center">
                                                    {/* {questionStrength[iconChooseIndex]} */}
                                                    อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                                </h5>
                                                :
                                                <span></span>
                                        }
                                        {
                                            (answer[iconChooseIndex] && answer[iconChooseIndex].description) ?
                                                <div>
                                                    <h5 className="title" align="center">
                                                        {answer[iconChooseIndex].name}
                                                    </h5>
                                                    <p>{answer[iconChooseIndex].description}</p>
                                                </div>
                                                :
                                                <span></span>
                                        }
                                    </div>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }
                    <Row>
                        <Col className="w-100 px-4">
                            <h4 class="font-sarabun-bold text-center">ลองเล่าเหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของนักเรียน</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="w-100 px-4 pt-3">
                            <div className={`border-radius-12 border-blue p-3 text-left overflow-7 ${alreadyAnswer ? 'div-ans' : 'bg-white'}`}>
                                <textarea className={`w-100 text no-border-line evaluate-placeholder ${alreadyAnswer ? 'div-ans' : ''}`} value={answer && answer[3] && answer[3].answer ? answer[3].answer : ''} placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={handleTextAnswer} readOnly={alreadyAnswer}></textarea>
                            </div>
                        </Col>
                    </Row>
                    {
                        (!alreadyAnswer) ?
                            <Row>
                                <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                                    <Button className="bluesky d-inline py-1 py-1 py-md-2 btn font-sarabun-bold" onClick={() => { validateForm(); }} >บันทึก</Button>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }
                </Col>
            </Row>
            <Row className="pt-3 pb-5 report-loading">
                <Col>Loading...</Col>
            </Row>
            <Row className="pt-3 pb-5 report-tab">
                <Col className="main-evaluate-overview">
                    <Row>
                        <Col className="w-100 text-center">
                            <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0">
                        <Col className="px-0">
                            <MultiCarouselPage data={data1} responsive={data1.length > 3 ? responsive2 : responsive3} />
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0 tab0 tab">
                    </Row>


                    {/* <Row>
                        <Col className="w-100 text-center pt-3">                           
                        <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search"/>  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0">
                        <Col className="px-0">
                            <MultiCarouselPage data={data2}  responsive={data2.length > 3 ? responsive2 : responsive3} />                           
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0 tab1 tab">
                    </Row>


                    <Row>
                        <Col className="w-100 text-center pt-3">                           
                        <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search"/>  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0">
                        <Col className="px-0">
                            <MultiCarouselPage data={data3} responsive={data3.length > 3 ? responsive2 : responsive3} />                           
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0 tab2 tab">
                    </Row> */}


                    <Row>
                        <Col className="w-100 text-center pt-3">
                            <h4 class="font-sarabun-bold">เขามองเห็นอะไรในตัวเอง?</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0">
                        <Col className="px-0">
                            <Col className="border-radius-12 text-left overflow-7 p-3  div-ans" >{testSelf}</Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="w-100 text-center pt-3">
                            {/* <h4 class="font-sarabun-bold">เหตุการณ์ที่ทำให้เพื่อนๆ มองเห็นอุปนิสัยเชิงบวกของเรา</h4> */}
                            <h4 class="font-sarabun-bold">เพื่อนๆ เห็นอะไรในตัวเขา</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 bg-white mx-0">
                        <Col className="px-0">
                            <MultiCarouselPage data={text1} responsive={responsive3} />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <MyVerticallyCenteredModal
                show={modalShow}
                onShow={() => {preventDoubleAnswer()}}
                onHide={() => { setModalShow(false); setModalAnswer(null); }}
            />
            <Modal
                show={modalShowEndActivity}
                onHide={() => { setModalShowEndActivity(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                {(modalShowEndActivityType === 'validate') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>กรุณาค้นหาอุปนิสัยเชิงบวกให้ครบก่อนจะทำการบันทึก</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { setModalShowEndActivity(false); }}>กลับกิจกรรม</Button>
                    </Modal.Body>
                ) : (modalShowEndActivityType == 'RECORD_ALREADY_EXIST') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>นักเรียนถูกประเมินแล้ว ไม่สามารถประเมินซ้ำได้ค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { window.location.reload() }}>ตกลง</Button>
                    </Modal.Body>
                ) : (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>ระบบได้ทำการบันทึกข้อมูลเรียบร้อยแล้วค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { window.location.reload() }}>ตกลง</Button>
                    </Modal.Body>
                )}
            </Modal>
        </div>
    )

    function clickTab(target) {
        if (target === '.report-click') {
            $('.report-click').addClass("text-magenta font-sarabun-bold");
            $('.evaluate-click').removeClass("text-magenta font-sarabun-bold");
            $('.report-tab').removeClass("d-none");
            $('.evaluate-tab').addClass("d-none");
            $('.evaluate-click').addClass("gray-text4");
        } else {
            $('.evaluate-tab').removeClass("d-none");
            $('.report-tab').addClass("d-none");
            $('.evaluate-click').addClass("text-magenta font-sarabun-bold");
            $('.report-click').removeClass("text-magenta font-sarabun-bold");
        }

    }

    function myloop(data) {
        var elementExists = $(".carousel-div").length > 0;
        if (elementExists || data.length === 0) {
            setTimeout(function () {
                if ($('.report-click').hasClass('text-magenta')) {
                    $('.report-tab').removeClass('d-none')
                } else {
                    $('.report-tab').addClass('d-none')
                }

                $('.report-loading').addClass("d-none");
            }, 1500);
        } else {
            setTimeout(function () {
                myloop(data)
            }, 1000);
        }
    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="strength-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row className="py-3 person-choose-strength px-md-4 d-none d-md-flex">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        {strengths.map((strength, i) => (
                            <div key={i} className="col-12 col-md-4" align="left">
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 100, hide: 300 }}
                                    overlay={
                                        <Tooltip id="button-tooltip" className='custom-bottom-tooltip' {...props}>
                                            {strength.description}
                                        </Tooltip>
                                    }
                                >
                                    <div className={`item my-1 my-md-2 p-1 click-pointer border-radius-5 ${strength.id}`} onClick={() => { handleAnswer(strength); setModalShow(false); }}>
                                        <img className="step-img" width="58" src={strength.imageUrl} /> {strength.name}
                                    </div>
                                </OverlayTrigger>
                            </div>
                        ))}
                    </Row>
                    <Row className="d-flex d-md-none person-collapse">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        <Col>
                            <Accordion>
                                {strengths.map((strength, i) => (
                                    <Card key={`mobi-${i}`} className={`mobi-${i} ${strength.id}`}>
                                        <Accordion.Toggle as={Card.Header} eventKey={i + 1} onClick={() => { handleActiveIndex(`.mobi-${i}`) }}>
                                            <img className="step-img" width="52" src={strength.imageUrl} />  {strength.name}
                                            <div class="arrow">
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey={i + 1}>
                                            <Card.Body>
                                                <div>
                                                    {strength.description}
                                                </div>
                                                <div align="center">
                                                    <Button className="choose-btn" onClick={() => { handleAnswer(strength); setModalShow(false); }}
                                                    // disabled={answer[0].answer === strength.id || answer[1].answer === strength.id || answer[2].answer === strength.id}
                                                    >เลือก</Button>
                                                </div>

                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function validateForm() {
        if (
            answer && answer[0] && answer[1] && answer[2] && answer[3] &&
            answer[0].answer && answer[1].answer &&
            answer[2].answer && answer[3].answer
        ) {
            saveAnswer()
        } else {
            setModalShowEndActivity(true)
            setModalShowEndActivityType('validate')
        }
    }

    function handleTextAnswer(event) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        if (answerData.length > 0) {
            answerData[3].answer = event.target.value
            postAnswerData[3].values = [event.target.value]
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
        }
    }

    function handleAnswer(strength) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        console.log(answerData)
        if (answerData.length > 0 && strength.id !== null && strength.imageUrl !== null) {
            for (let [i, val] of answerData.entries()) {
                if (i !== modalAnswer && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[modalAnswer].answer = strength.id
            answerData[modalAnswer].name = strength.name
            answerData[modalAnswer].description = strength.description
            const filename = strength.imageUrl.replace(/^.*[\\\/]/, '')
            answerData[modalAnswer].image = `/images/strengths/active/${filename}`
            postAnswerData[modalAnswer].values = [strength.id]
            console.log(postAnswerData)
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
            setIconChooseIndex(modalChooseIndex)
        }
    }

    function callChooseStrengthModal(index) {
        if (!alreadyAnswer) {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function focusChooseStrengthModal(index) {
        const answerData = [...answer]
        if (answerData && answerData.length > 0 && answerData[index] && answerData[index].answer) {
            for (let [i, val] of answerData.entries()) {
                if (i !== index && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[index].image = answerData[index].image.replace("/inactive", "/active");
            setAnswer(answerData)
            setIconChooseIndex(index)
        } else {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function saveAnswer() {
        console.log('55555555555555555555555555555555');


        UserService.postPersonEvaluationForms({
            "userId": AuthService.getCurrentUserId(),
            "targetId": targetId,
            "roomId": AuthService.getCurrentUser().room.id,
            "answers": postAnswer
        }).then((res) => {
            console.log(res)
            if (res.data && res.data.status.code === 'SUCCESS') {
                setModalShowEndActivity(true)
                setModalShowEndActivityType('complete')
            }
        },
            (error) => {
                console.log(error);
                console.log(error.response.data);
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'RECORD_ALREADY_EXIST') {
                    setModalShowEndActivity(true);
                    setModalShowEndActivityType('RECORD_ALREADY_EXIST');
                    // alert(`นักเรียนถูกประเมินแล้ว ไม่สามารถประเมินซ้ำได้ค่ะ`);
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            }

        )
    }

    function handleAlreadyAnswer(apiStrengths, answers) {
        const str0 = apiStrengths.filter(function (strength) { return strength.id === answers[0].values[0] })[0];
        const str1 = apiStrengths.filter(function (strength) { return strength.id === answers[1].values[0] })[0];
        const str2 = apiStrengths.filter(function (strength) { return strength.id === answers[2].values[0] })[0];
        if (str0 && str0.imageUrl && str1 && str1.imageUrl && str2 && str2.imageUrl) {
            const imgPath0 = str0.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath1 = str1.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath2 = str2.imageUrl.replace(/^.*[\\\/]/, '')
            setAnswer([
                { 'answer': answers[0].values[0], 'image': `/images/strengths/inactive/${imgPath0}`, 'name': str0.name, 'description': str0.description },
                { 'answer': answers[1].values[0], 'image': `/images/strengths/inactive/${imgPath1}`, 'name': str1.name, 'description': str1.description },
                { 'answer': answers[2].values[0], 'image': `/images/strengths/inactive/${imgPath2}`, 'name': str2.name, 'description': str2.description },
                { 'answer': answers[3].values[0] }
            ])
            // checkPercentAnswer(); 
        }
    }

    function cardClick(key, tab, str, ele) {

        $('.tab').html('');


        // if($('body').find(ele).hasClass( "border-card")){              
        $('body').find('.cardimage').removeClass("border-card");
        // }
        $('body').find(ele).addClass("border-card");
        $(tab).html('<div class="str-div"><h5 class="font-sarabun-bold">' + str.name + '</h5><h6>' + str.description + '</h6></div>');

    }


    function preventDoubleAnswer() {
        $('.person-choose-strength .item').addClass('click-pointer');
        $('.person-choose-strength .item').css("pointer-events", "unset");
        $('.person-choose-strength .item').css("opacity", "1");
        var imgsrc = '';
        $(".strengths-box img.w-100").each(function() {  
            imgsrc = this.src;           
            var tempText = imgsrc.split('/');    
            tempText = tempText[tempText.length-1];
            tempText = "." + tempText.replace(".png", "");
            console.log(tempText);
            console.log( $(tempText));
            $(tempText).removeClass('click-pointer');
            $(tempText).css("pointer-events", "none");
            $(tempText).css("opacity", "0.4");         

        });  
    }
}

export default EvaluateStudent